import type { LinkProps } from '@/components/Link';
import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';

import { Link } from '@/components/Link';
import { mergeProps } from '@/utils/merge';
import { Image } from './Image';

export interface StandaloneImageProps extends StandaloneComponentProps<typeof Image> {
  alt?: React.ComponentProps<typeof Image>['alt'];
  byline?: React.ReactNode;
  caption?: React.ReactNode;
  link?: LinkProps;
  src?: React.ComponentProps<typeof Image>['src'];
}

export const StandaloneImage: StandaloneComponent<StandaloneImageProps> = ({
  alt,
  byline,
  caption,
  link,
  src,
  ...props
}) => {
  return (
    <Image.Group {...props}>
      {link?.href && (
        <Link
          {...mergeProps(link, {
            options: {
              cover: true,
              'aria-label':
                alt ||
                (typeof caption === 'string' && caption) ||
                (typeof byline === 'string' && byline) ||
                link.href
                  ?.replace(/^https?:\/\/[^/]+/, '')
                  .replace(/\//g, ' ')
                  .replace(/-/g, ' ')
                  .trim() ||
                'Läs mer',
            },
          })}
        />
      )}

      <Image {...{ src: src!, alt: alt! }} {...props} />

      {(caption || byline) && (
        <Image.CaptionGroup>
          {caption && <Image.Caption>{caption}</Image.Caption>}
          {byline && <Image.Byline>{byline}</Image.Byline>}
        </Image.CaptionGroup>
      )}
    </Image.Group>
  );
};
